module.exports = require('./$.hide');


/*****************
 ** WEBPACK FOOTER
 ** ./~/pui-react-back-to-top/~/pui-react-animation/~/babel-runtime/~/core-js/library/modules/$.redefine.js
 ** module id = 100
 ** module chunks = 0
 **/